<template>
  <div>
    <v-md-editor
      v-model="mdText"
      height="600px"
      :left-toolbar="leftToolbar"
      :right-toolbar="rightToolbar"
      :toolbar="customToolbar"
      :disabled-menus="[]"
    />
    <ImageConf ref="imgConf" :showData="imgConfData" @returnConf="fillImageContent($event)" />
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import ImageConf from './ImageConf'

export default {
  name: 'markdown',
  mixins: [Error],
  props: ['text'],
  components: {ImageConf},
  data () {
    return {
      mdText: this.text,
      fpToken: '',
      imgConfData: { imgUrl: '', align: 'center', width: '500', height: '300', alt: '', editor: null },
      leftToolbar: 'undo redo clear | h bold italic strikethrough quote | align emoji tip | ul ol todo-list table hr | link new-image code | save',
      rightToolbar: 'preview sync-scroll fullscreen',
      customToolbar: {
        'new-image': {
          name: 'new-image',
          icon: 'v-md-icon-img',
          title: '插入图片',
          menus: [
            {
              name: 'image-link',
              text: '添加图片链接',
              action (editor, config) {
                editor.execCommand('image')
              }
            },
            {
              name: 'upload-image',
              text: '上传本地图片',
              action (editor) {
                let _self = editor.$parent.$parent
                let _this = editor.$parent
                editor.uploadConfig = editor.uploadImgConfig
                editor.$nextTick(async () => {
                  const event = await editor.$refs.uploadFile.upload()
                  let file = event.target.files[0]
                  if (file.size / 1024 / 1024 > 10) {
                    _self.handleError({data: {msg: '上传图片大小不可超过10M'}})
                    return false
                  }
                  _this.uploadFile(file, editor)
                })
              }
            }
          ]
        },
        align: {
          name: 'align',
          icon: 'fa fa-align-justify',
          title: '对齐方式',
          menus: [
            {
              name: 'left',
              text: '靠左',
              action (editor) {
                let _this = editor.$parent
                editor.insert((select) => {
                  return {
                    // 要插入的文本
                    text: _this.handleAlign('left', select || ''),
                    // 插入后要选中的文本
                    selected: ''
                  }
                })
              }
            },
            {
              name: 'center',
              text: '居中',
              action (editor) {
                let _this = editor.$parent
                editor.insert((select) => {
                  return {
                    // 要插入的文本
                    text: _this.handleAlign('center', select || ''),
                    // 插入后要选中的文本
                    selected: ''
                  }
                })
              }
            },
            {
              name: 'right',
              text: '靠右',
              action (editor) {
                let _this = editor.$parent
                editor.insert((select) => {
                  return {
                    // 要插入的文本
                    text: _this.handleAlign('right', select || ''),
                    // 插入后要选中的文本
                    selected: ''
                  }
                })
              }
            }
          ]
        }
      }
    }
  },
  created () {
    this.getFpToken()
  },
  methods: {
    fillImageContent (data) {
      data.editor.insert((selected) => {
        const prefix = `<div align="${data.align}">\n`
        const suffix = `</div>\n`
        const content = `    <img src="${data.imgUrl}" width="${data.width}" height="${data.height}" alt="${data.alt}" />\n`

        return {
          // 要插入的文本
          text: `${prefix}${content}${suffix}`,
          // 插入后要选中的文本
          selected: ''
        }
      })
    },
    getFpToken () {
      this.$ajax.get(api.getFpToken(consts.FP_TYPE)).then((res) => {
        this.fpToken = res.token
      })
    },
    uploadFile (file, editor) {
      let fd = new FormData()
      fd.append('fpfile', file)
      fd.append('Authorization', this.fpToken)
      this.$ajax.post(api.getFpUpload(), fd, {headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {
      }, (res) => {
        if (res.status === 200) {
          this.imgConfData = {
            imgUrl: JSON.parse(res.data.body).url, align: 'center', width: '500', height: '300', alt: '', editor: editor
          }
          this.$refs.imgConf.modalShow()
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    handleAlign (align, text) {
      const prefix = `::: align-${align}\n`
      const suffix = `:::\n`
      const content = `${text}\n`

      return `${prefix}${content}${suffix}`
    }
  }
}
</script>

<style>
  .fa {
    font: normal normal normal 14px/2 FontAwesome !important;
  }
  [class*='fa-'] {
    font-size: 14px !important;
    font-style: normal !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .v-md-icon-arrow-down {
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// Markdown.vue?7eda19a1